import { get } from 'lodash';

import {
  SET_USER,
  SET_AUTH_STATUS,
  ADMIN_REGISTER_NEW_USER,
  SET_COOKIES_CONSENT,
  USER_LOGOUT_AUTH,
  SET_ROGUE_USER,
  SET_ROGUE_TENANT_SSO,
  SET_REGISTRATION_IN_PROGRESS,
} from '../actionTypes';

const getInitialState = () => ({
  consentedToCookies: false,
  loading: true,
  isAuthenticated: false,
  user: null,
  jwtToken: null,
  role: 'Admin', // todo: default to User,
  // rogue user meaning: trying to sign into tenant they don't belong to
  isRogueUser: false,
  // rogue tenant sso meaning: user authenticates with Tenant A's SSO but switched to Tenant B before registering
  isRogueTenantSSO: false,
  registrationInProgress: false,
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SET_USER: {
      const { user } = action.payload;

      if (user == null) {
        return {
          ...state,
          user,
        };
      }

      const ssoProviderName =
        user &&
        user.signInUserSession &&
        user.signInUserSession.idToken &&
        user.signInUserSession.idToken.payload &&
        user.signInUserSession.idToken.payload.identities &&
        user.signInUserSession.idToken.payload.identities[0]?.providerName;

      // standard users
      const emailStandard = get(user, 'attributes.email');

      // 3rd party federation
      const emailFederated = get(
        user,
        'signInUserSession.idToken.payload.identities[0].userId'
      );

      return {
        ...state,
        user: {
          attributes: {
            ...user.attributes,
            email: emailStandard || emailFederated,
            providerName: ssoProviderName || '',
          },
        },
      };
    }
    case SET_AUTH_STATUS: {
      const { authenticated, session } = action.payload;
      let jwtToken = null;

      if (session !== null && authenticated) {
        jwtToken = session.idToken.getJwtToken();
      }

      return {
        ...state,
        jwtToken,
        isAuthenticated: authenticated,
        loading: false,
      };
    }
    case ADMIN_REGISTER_NEW_USER: {
      return {
        ...state,
      };
    }
    case SET_COOKIES_CONSENT: {
      return {
        ...state,
        consentedToCookies: true,
      };
    }
    case SET_REGISTRATION_IN_PROGRESS: {
      return {
        ...state,
        registrationInProgress: action.payload,
      };
    }
    case USER_LOGOUT_AUTH: {
      return getInitialState();
    }
    case SET_ROGUE_USER: {
      return {
        ...state,
        isRogueUser: action.payload,
      };
    }

    case SET_ROGUE_TENANT_SSO: {
      return {
        ...state,
        isRogueTenantSSO: action.payload.isRogueTenantSSO,
      };
    }
    default:
      return state;
  }
}
